import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mail, Download, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminNewsletter() {
    const [data, setData] = useState(null);

    const load = () => api.get("/admin/newsletter").then((r) => setData(r.data));
    useEffect(() => { load(); }, []);

    const downloadCsv = async () => {
        const r = await api.get("/admin/newsletter/export.csv", { responseType: "blob" });
        const url = window.URL.createObjectURL(r.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = "newsletter-subscribers.csv";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const unsub = async (email) => {
        if (!window.confirm(`Anular subscrição de ${email}?`)) return;
        await api.delete(`/admin/newsletter/${encodeURIComponent(email)}`);
        toast.success("Subscritor removido");
        load();
    };

    if (!data) return <Loader2 className="animate-spin" />;

    return (
        <div data-testid="admin-newsletter">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <div className="label-mono text-magenta">Newsletter</div>
                    <h1 className="font-display font-black text-3xl">Subscritores</h1>
                </div>
                <button onClick={downloadCsv} className="btn-primary" data-testid="export-newsletter-btn">
                    <Download size={16} /> Exportar CSV
                </button>
            </div>

            <div className="grid sm:grid-cols-3 gap-0 border-2 border-ink mb-6">
                <div className="p-5 bg-white border-r-2 border-ink">
                    <Mail className="text-magenta" size={18} />
                    <div className="label-mono mt-2">Total</div>
                    <div className="font-display font-black text-3xl">{data.total}</div>
                </div>
                <div className="p-5 bg-white border-r-2 border-ink">
                    <div className="label-mono">Activos</div>
                    <div className="font-display font-black text-3xl text-magenta">{data.active}</div>
                </div>
                <div className="p-5 bg-white">
                    <div className="label-mono">Anulados</div>
                    <div className="font-display font-black text-3xl text-ink/40">{data.total - data.active}</div>
                </div>
            </div>

            {data.subscribers.length === 0 ? (
                <div className="text-center py-16 border-2 border-dashed border-ink/30 font-mono text-ink/60">
                    Sem subscritores ainda. Partilhe a sua loja para começar a receber emails!
                </div>
            ) : (
                <div className="border-2 border-ink bg-white">
                    <table className="w-full font-mono text-sm">
                        <thead className="bg-ink text-white">
                            <tr><th className="p-3 text-left">Email</th><th>Subscrito em</th><th>Origem</th><th>Estado</th><th></th></tr>
                        </thead>
                        <tbody>
                            {data.subscribers.map((s) => (
                                <tr key={s.email} className="border-b border-ink/10">
                                    <td className="p-3">{s.email}</td>
                                    <td className="text-center text-xs text-ink/60">{(s.subscribed_at || "").slice(0, 10)}</td>
                                    <td className="text-center text-xs text-ink/60">{s.source || "—"}</td>
                                    <td className="text-center">
                                        <span className={`px-2 py-0.5 text-xs ${s.unsubscribed ? "bg-ink/20" : "bg-accent-green text-white"}`}>
                                            {s.unsubscribed ? "OFF" : "ON"}
                                        </span>
                                    </td>
                                    <td className="text-right p-3">
                                        {!s.unsubscribed && (
                                            <button onClick={() => unsub(s.email)} className="text-red-600 hover:underline" title="Anular">
                                                <Trash2 size={14} />
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
